module.exports = __webpack_public_path__ + "img/inWhite.2de1fd23.svg";